import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import {
  OpeningText,
  OpeningTextHeading,
  OpeningTextSubHeading,
  SectionTitleBody
} from "@silversea-ssc/ui-components-react";
import React from "react";
import {
  SanityMultilingualBlockContent,
  SanityMultilingualString
} from "types/graphql-types";
import { BlockContent } from "components/BlockContent";
import ExpiresOnChip from "components/ExpiresOnChip/ExpiresOnChip";
import * as styles from "./OffersPerPromo.module.scss";
import { Language } from "src/utils/localization/languages/types";
import { formatDate } from "src/utils/date";
import { forceResTimezone } from "src/utils/date/forceResTimezone";
import { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
const Countdown = React.lazy(() => import("components/Countdown/Countdown"));

export const offerTitle = (
  language: Language,
  title?: SanityMultilingualBlockContent | SanityMultilingualString,
  expiresOn?: Date,
  tokenValues?: TokenValues,
  showCountdown?: boolean,
  countdownLabel?: string
) => {
  const formattedDate = expiresOn
    ? formatDate(expiresOn, language.ogLang, {
        day: "numeric",
        month: "long",
        year: "numeric"
      })
    : undefined;

  return (
    <OpeningText>
      {expiresOn && showCountdown && (
        <div className={styles.countdownContainer}>
          <React.Suspense>
            <Countdown
              expireDate={forceResTimezone(expiresOn)}
              label={countdownLabel ?? t`OFFER ENDS IN`}
            />
          </React.Suspense>
        </div>
      )}
      <OpeningTextHeading>
        <BlockContent value={title?.localized} tokens={tokenValues || {}} />
      </OpeningTextHeading>
      {expiresOn && !showCountdown && (
        <OpeningTextSubHeading>
          <SectionTitleBody>
            <ExpiresOnChip background="neutral05" className={styles.expiresOn}>
              <Trans>Offer expires on</Trans> {formattedDate}
            </ExpiresOnChip>
          </SectionTitleBody>
        </OpeningTextSubHeading>
      )}
    </OpeningText>
  );
};

export const offerNotAvailable = () => (
  <OpeningText>
    <OpeningTextHeading>
      <Trans>This exclusive offer is not available in your country</Trans>
    </OpeningTextHeading>
  </OpeningText>
);
